// extracted by mini-css-extract-plugin
export default {"wrapper":"vnMqJMkmOr7LzVY1wkjt"};